<ng-container *ngIf="!scope.config.disableJobSearchPage; else showNoAccessMsg">
  <ng-container *ngIf="!scope.forwardJobSearchPageExists; else showForwardPageMsg">

    <div class="opp-hero"
        appTextEditContainer="opportunity-list"
        name="Hero Text"
        [title]="'FIND_JOBS'">
      <div class="opp-hero__inner">
        <h1 class="opp-hero__title">{{scope.getText | transform:'FIND_JOBS'}}</h1>
      </div>
    </div>

    <div class="opp-layout" disabledDiv>

      <!-- Sidebar (desktop) -->
      <aside class="opp-sidebar">
        <ng-container *ngTemplateOutlet="filterContent"></ng-container>
      </aside>

      <!-- Mobile filter drawer backdrop -->
      <div class="opp-filter-backdrop" *ngIf="filtersOpen" (click)="filtersOpen = false"></div>

      <!-- Mobile filter drawer -->
      <div class="opp-filter-drawer" [class.opp-filter-drawer--open]="filtersOpen">
        <div class="opp-filter-drawer__header">
          <span class="opp-filter-drawer__title">{{scope.getText | transform:'FILTERS'}}</span>
          <button class="opp-filter-drawer__close" (click)="filtersOpen = false" aria-label="Close filters">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <ng-container *ngTemplateOutlet="filterContent"></ng-container>
      </div>

      <!-- Main content -->
      <div class="opp-main">

        <div class="opp-main__toolbar">
          <button class="opp-filters-btn" (click)="filtersOpen = true">
            <mat-icon>tune</mat-icon> {{scope.getText | transform:'FILTERS'}}
          </button>
          <span class="opp-main__results-count" *ngIf="scope.pagination.total > 0">
            {{scope.getText | transform:'PAGE_OF_JOBS':{page:scope.pagination.page+1,total:scope.pagination.total} }}
          </span>
          <mat-form-field appearance="outline" class="opp-main__sort">
            <mat-label>{{scope.getText | transform:'SORT_BY'}}</mat-label>
            <mat-select [(ngModel)]="scope.params.sort" (selectionChange)="scope.search()" name="sortBy">
              <mat-option value="lastUpdated:-1">{{scope.getText | transform:'LAST_UPDATED'}}</mat-option>
              <mat-option value="createdDate:-1">{{ scope.getText | transform:'CREATED_DATE' }}</mat-option>
              <mat-option value="name">{{scope.getText | transform:'NAME'}}</mat-option>
              <mat-option value="compensation" *ngIf="!scope.config.disableCompensationFilter">{{ scope.getText | transform:'COMPENSATION' }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="opp-list">

          <!-- Skeleton cards while loading -->
          <ng-container *ngIf="scope.loading">
            <div class="ske-cards">
              <div class="ske-card" *ngFor="let i of [1,2,3,4,5]">
                <div class="ske-card__title ske-shimmer"></div>
                <div class="ske-card__subtitle ske-shimmer"></div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="!scope.loading && scope.opps && scope.opps.length > 0; else noResults">
            <div class="opp-card" *ngFor="let opp of scope.opps">
              <div class="opp-card__header">
                <a class="opp-card__title"
                  [routerLink]="['/details', opp._id]">{{ opp.name }}</a>
                <span class="opp-card__badge" *ngIf="getEmploymentType(opp)">
                  {{ getEmploymentType(opp) }}
                </span>
              </div>
              <div class="opp-card__meta">
                <span class="opp-card__meta-item" *ngIf="opp.externalId">
                  <mat-icon>description</mat-icon>
                  {{ opp.externalId }}
                </span>
                <span class="opp-card__meta-item" *ngIf="opp.display?.client">
                  <mat-icon>group</mat-icon>
                  {{ opp.display.client }}
                </span>
                <span class="opp-card__meta-item" *ngFor="let pill of opp.display?.pills">
                  <mat-icon>{{ pill.icon }}</mat-icon>
                  {{ pill.value }}
                </span>
              </div>
              <div class="opp-card__pills" *ngIf="opp.display?.labels?.length > 0">
                <span class="opp-card__pill" *ngFor="let label of opp.display.labels">
                  {{ label.value }}
                </span>
              </div>
            </div>
          </ng-container>

          <ng-template #noResults>
            <div class="opp-none-found" *ngIf="scope.noneFound && !scope.loading">
              <mat-icon>search</mat-icon>
              {{ scope.getText | transform:'NO_RESULTS_FOUND' }}
            </div>
          </ng-template>

          <mat-paginator
            [length]="scope.pagination.total"
            [pageIndex]="scope.pagination.page"
            [hidePageSize]="true"
            [pageSize]="10"
            (page)="scope.changePage($event)">
          </mat-paginator>

        </div>
      </div>

    </div>

  </ng-container>
</ng-container>

<div class="talent-cta"
    *ngIf="scope.config.enableTalentCta !== false"
    appTextEditContainer="opportunity-list"
    name="Talent CTA"
    [title]="'TALENT_CTA_HEADING'"
    [body]="'TALENT_CTA_BODY'">
    <h2 class="talent-cta__heading">{{scope.getText | transform:'TALENT_CTA_HEADING'}}</h2>
    <p class="talent-cta__body">{{scope.getText | transform:'TALENT_CTA_BODY'}}</p>
    <a routerLink="/register" class="talent-cta__button">
        {{scope.getText | transform:'JOIN_TALENT_COMMUNITY_BUTTON'}} <mat-icon inline="true">north_east</mat-icon>
    </a>
</div>

<div class="talent-video"
    *ngIf="scope.config.enableTalentVideo !== false"
    appVideoEditContainer="opportunity-list"
    [currentUrl]="scope.component.assets?.video"
    name="YouTube Video">
    <h2 class="talent-video__heading"
        appTextEditContainer="opportunity-list"
        name="Talent Video Heading"
        [title]="'TALENT_VIDEO_HEADING'">{{scope.getText | transform:'TALENT_VIDEO_HEADING'}}</h2>
    <div class="talent-video__embed" *ngIf="scope.component.assets?.video">
        <iframe
            [src]="getSafeVideoUrl(scope.component.assets.video)"
            [title]="scope.getText | transform:'TALENT_VIDEO_HEADING'"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
        </iframe>
    </div>
</div>

<ng-template #filterContent>
  <div class="opp-sidebar__group">
    <label class="opp-sidebar__label" for="keywords">{{scope.getText | transform:'KEYWORD'}}</label>
    <mat-form-field appearance="outline" class="opp-sidebar__field">
      <input matInput id="keywords" [placeholder]="scope.getText | transform:'KEYWORDS'"
        [(ngModel)]="scope.params.keywords"
        (keydown.enter)="scope.search()">
    </mat-form-field>
  </div>

  <div class="opp-sidebar__group">
    <label class="opp-sidebar__label">{{scope.getText | transform:'LOCATION'}}</label>
    <mat-form-field appearance="outline" class="opp-sidebar__field">
      <input matInput [placeholder]="scope.getText | transform:'SEARCH_LOCATIONS'"
        [matAutocomplete]="sidebarAuto"
        [formControl]="scope.params.location">
    </mat-form-field>
    <mat-autocomplete #sidebarAuto="matAutocomplete" [displayWith]="scope.createLocationString" (optionSelected)="scope.search()">
      <mat-option *ngFor="let location of scope.locations" [value]="location">
        {{ scope.createLocationString | transform:location }}
      </mat-option>
    </mat-autocomplete>
  </div>

  <ng-container *ngIf="!scope.config.disableJobLabelFilter && (scope.availableLabels.length > 0 || scope.isAdmin)">
    <div class="opp-sidebar__group">
      <div class="opp-sidebar__group-header">
        <p class="opp-sidebar__label _editable--no-caption" appTextEditContainer="opportunity-list"
          [title]="'JOB_LABELS'" name="Job Labels"
          [innerText]="scope.getText | transform:'JOB_LABELS'"></p>
        <button class="opp-sidebar__clear" *ngIf="scope.params.jobLabel" (click)="clearJobLabel()">{{scope.getText | transform:'CLEAR'}}</button>
      </div>
      <mat-radio-group class="opp-sidebar__checklist" [(ngModel)]="scope.params.jobLabel" (change)="scope.search()">
        <mat-radio-button class="opp-sidebar__radio" *ngFor="let label of scope.availableLabels" [value]="label">{{label}}</mat-radio-button>
      </mat-radio-group>
    </div>
  </ng-container>

  <ng-container *ngIf="!scope.config.disableCareerLevelFilter">
    <div class="opp-sidebar__group">
      <div class="opp-sidebar__group-header">
        <p class="opp-sidebar__label">{{scope.getText | transform:'CAREER_LEVEL'}}</p>
        <button class="opp-sidebar__clear" *ngIf="scope.params.careerLevel" (click)="clearCareerLevel()">{{scope.getText | transform:'CLEAR'}}</button>
      </div>
      <mat-radio-group class="opp-sidebar__checklist" [(ngModel)]="scope.params.careerLevel" (change)="scope.search()">
        <mat-radio-button class="opp-sidebar__radio" value="STUDENT">{{scope.getText | transform:'STUDENT'}}</mat-radio-button>
        <mat-radio-button class="opp-sidebar__radio" value="ENTRYLEVEL">{{scope.getText | transform:'ENTRY_LEVEL'}}</mat-radio-button>
        <mat-radio-button class="opp-sidebar__radio" value="MIDCAREER">{{scope.getText | transform:'MID_CAREER'}}</mat-radio-button>
        <mat-radio-button class="opp-sidebar__radio" value="EXPERIENCED">{{scope.getText | transform:'EXPERIENCED_NON_MANAGER'}}</mat-radio-button>
        <mat-radio-button class="opp-sidebar__radio" value="MANAGER">{{scope.getText | transform:'MANAGER'}}</mat-radio-button>
        <mat-radio-button class="opp-sidebar__radio" value="EXECUTIVE">{{scope.getText | transform:'EXECUTIVE'}}</mat-radio-button>
        <mat-radio-button class="opp-sidebar__radio" value="SENIOREXECUTIVE">{{scope.getText | transform:'SENIOR_EXECUTIVE'}}</mat-radio-button>
      </mat-radio-group>
    </div>
  </ng-container>

  <div class="opp-sidebar__group" *ngIf="!scope.config.disableCompensationFilter">
    <label class="opp-sidebar__label">{{scope.getText | transform:'REMOTE_WORKING'}}</label>
    <mat-checkbox class="opp-sidebar__checkbox" [checked]="isRemoteChecked()" (change)="toggleRemote($event.checked)">{{scope.getText | transform:'EMPLOYEES_CAN_REMOTE_WORK'}}</mat-checkbox>
  </div>

  <button class="opp-sidebar__reset" (click)="resetSearch()">
    {{scope.getText | transform:'RESET_SEARCH'}}
  </button>
</ng-template>

<ng-template #showForwardPageMsg>
  <div class="opp-admin-msg">
    <mat-icon>settings</mat-icon>
    <h1>{{ scope.translations.FORWARD_PAGE_MSG }} :
      <a [href]="scope.config.forwardJobSearchPage" target="_blank">
        {{ scope.config.forwardJobSearchPage }}
      </a>
    </h1>
  </div>
</ng-template>

<ng-template #showNoAccessMsg>
  <div class="opp-admin-msg">
    <mat-icon>settings</mat-icon>
    <h1>{{ scope.translations.NO_ACCESS_JOB_SEARCH_PAGE }}</h1>
  </div>
</ng-template>
